import { Identifiable } from '@sr/dto';
import { FormikErrors } from 'formik';

export type FormTools<TDto extends Identifiable, TCreateDto, TUpdateDto, TFormData> = {
  toUpdateDto: (id: number, formData: TFormData) => TUpdateDto;
  toCreateDto: (formData: TFormData) => TCreateDto;
  fromDto: (item: TDto) => TFormData;
  validate: (values: TFormData) => FormikErrors<TFormData>;
  emptyValues: () => TFormData;
};

export const VALIDATION_REQUIRED_FIELD = 'Обязательное поле';
export const VALIDATION_GREATER_THAN_ZERO = 'Значение должно быть больше нуля';
export const VALIDATION_PERCENTAGE = 'Значение должно быть от 0 до 100';
